import { IconProvider } from './social-media.pipe';

export const provideSocialMediaIconResolver = (
  iconProvider: (icon: string) => Promise<{ default: string }>,
) => [{ provide: IconProvider, useValue: iconProvider }];
